import * as dom from '../modules/wpstg-dom-utils.js';

class BackupPluginsNotice {
  constructor(wpstgObject = wpstg) {
    this.wpstgObject = wpstgObject;
    this.wpstgBackupNoticeCloseButton = null;
    this.wpstgBackupNoticeReminderButton = null;
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', ()=>{
      this.wpstgBackupNoticeCloseButton = document.getElementById('wpstg-backup-plugin-notice-close');
      this.wpstgBackupNoticeReminderButton = document.getElementById('wpstg-backup-plugin-notice-remind-me');
      this.addEvent();
    });
  }

  addEvent() {
    if (this.wpstgBackupNoticeCloseButton !== null) {
      this.wpstgBackupNoticeCloseButton.addEventListener('click', ()=>{
        this.closeBackupPluginNotice();
      });
    }

    if (this.wpstgBackupNoticeReminderButton !== null) {
      this.wpstgBackupNoticeReminderButton.addEventListener('click', ()=>{
        this.closeBackupPluginNotice('wpstg_backup_plugin_notice_remind_me');
      });
    }
  }

  closeBackupPluginNotice(action = 'wpstg_backup_plugin_notice_close') {
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: action,
        nonce: this.wpstgObject.nonce,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
    }).then((data) => {
      if (data.success) {
        dom.qs('.wpstg-backup-plugin-notice-container').style.opacity = 0;
      }
    }).catch((error) => {
      dom.qs('.wpstg-backup-plugin-notice-container').style.opacity = 0;
    });
  }
}

export default new BackupPluginsNotice();
